import { Routes } from "@angular/router";
import { RoleGuard } from "../Authentication/guards/role.guard";
import { Role } from "../Authentication/models/roles-permissions.model";
import { NgxPermissionsRouterData } from "ngx-permissions";
import { CUSTOMER_ROUTES } from "../Customer/customer-routes";
import { VENDOR_ROUTES } from "../vendor/vendor.routes";
import { ADMIN_ROUTES } from "../Admin/admin.routes";
import { AUTHENTICATION_ROUTES } from "../Authentication/authentication.routes";

export const MAIN_LAYOUT_ROUTES: Routes = [
  {
    path: "error",
    children: [
      {
        path: "not-found",
        loadComponent: () =>
          import("./error/not-found-error/not-found-error.component")
            .then(m => m.NotFoundErrorComponent)
      },
      {
        path: "access-denied",
        loadComponent: () =>
          import("./error/access-denied-error/access-denied-error.component")
            .then(m => m.AccessDeniedErrorComponent)
      }
    ]
  },
  {
    path: "",
    loadComponent: () =>
      import("./layouts/main-layout/main-layout.component")
        .then(m => m.MainLayoutComponent),
    children: [
      {
        path: "home",
        canActivate: [RoleGuard],
        data: {
          roles: {
            only: [
              Role.Customer,
              Role.Guest,
              Role.BusinessCustomer
            ],
            redirectTo: "error/access-denied" // ✅ RELATIVE
          } as NgxPermissionsRouterData
        },
        loadChildren: () => CUSTOMER_ROUTES
      },
      { path: "auth", loadChildren: () => AUTHENTICATION_ROUTES },
      { path: "admin", loadChildren: () => ADMIN_ROUTES },
      { path: "vendor", loadChildren: () => VENDOR_ROUTES }
    ]
  }
];
